import { render } from "./PersonaItem.vue?vue&type=template&id=8806348c&scoped=true"
import script from "./PersonaItem.vue?vue&type=script&lang=js"
export * from "./PersonaItem.vue?vue&type=script&lang=js"

import "./PersonaItem.vue?vue&type=style&index=0&id=8806348c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8806348c"]])

export default __exports__